import React, {Component} from 'react';
import {
    Link,
    Redirect
} from "react-router-dom";
import {Formik, Field, FieldArray} from 'formik';
import _ from 'lodash';
import config from '../config';
import moment from "moment";
import {AuthContext} from "../context/auth";
import fetcher from "../context/fetcher";

export default class UniversalVew extends Component {
    static contextType = AuthContext

    constructor(props, context) {
        super(props);
        this.authContext = context;
        let {id, collectionName } = this.props.match.params;
        this.collectionName = collectionName;
        this.state = {
            id,
            obj: null
        };
        this.init = this.init.bind(this);
        this.save = this.save.bind(this);
        this.init(id);
    }

    async init(id) {
        if (id == "new") {
            this.state.obj = {
                _id: "new",
                name: ""
            }
        } else {
            let that = this;
            fetcher(`${config.API()}dbtable/${this.collectionName}/${id}`)
                .then(response => response.json())
                .then(team => {
                    that.setState({obj: team})
                });
        }
    }

    async save(values) {
        console.log(values);
        for(let key in values){
            if(values[key] === ""){
                values[key] = null;
            }
        }
        var body = JSON.stringify(values);
        fetcher(`${config.API()}dbtable/${this.collectionName}/save`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body
        })
            .then(response => response.json())
            .then(data => {
                this.setState({redirect: `/view/${this.collectionName}`});
            });
    }

    render() {

        const getInputType = (value) => {
            if (moment(value, moment.ISO_8601, true).isValid()) return 'datetime-local';
            if (value instanceof Date ) return 'datetime-local';
            if (typeof value === 'number') return 'number';
            if (typeof value === 'boolean') return 'checkbox';
            if (Array.isArray(value)) return 'array';
            if (typeof value === 'object' && value !== null) return 'object';
            return 'text';
        };

        const renderField = (key, value, path = '', handleChange, setFieldValue) => {
            const inputType = getInputType(value);
            const fullPath = path ? `${path}.${key}` : key;

            if (inputType === 'object') {
                return (
                    <div key={fullPath} className="form-group row">
                        <label className="col-sm-2 col-form-label">{key}</label>
                        <div className="col-sm-10">
                            {Object.entries(value).map(([nestedKey, nestedValue]) =>
                                renderField(nestedKey, nestedValue, fullPath, handleChange, setFieldValue)
                            )}
                        </div>
                    </div>
                );
            }

            if (inputType === 'array') {

                const addItem = () => {
                    const newItem = value.length > 0 && typeof value[0] === 'object'
                        ? { ...value[0] } // Копируем структуру первого объекта
                        : ''; // Пустая строка для примитивов
                    setFieldValue(fullPath, [...value, newItem]);
                };

                const removeItem = (index) => {
                    const newArray = value.filter((_, i) => i !== index);
                    setFieldValue(fullPath, newArray);
                };

                return (
                    <div key={fullPath} className="form-group row">
                        <label className="col-sm-2 col-form-label">{key} <button type="button" className="btn btn-outline-primary btn-circle btn-sm" onClick={addItem} ><i className="fa fa-plus"></i></button></label>

                        <div className="col-sm-10">
                            {value.map((item, index) => {
                                const arrayPath = `${fullPath}[${index}]`;
                                if (typeof item === 'object' && item !== null) {
                                    return (
                                        <div key={arrayPath} className="form-group row">
                                            <label className="col-sm-1 col-form-label">{`#${index+1}`}</label>
                                            <div className="col-sm-10">
                                                {Object.entries(item).map(([nestedKey, nestedValue]) =>
                                                    renderField(nestedKey, nestedValue, arrayPath, handleChange, setFieldValue)
                                                )}
                                            </div>
                                            <div className="col-sm-1">
                                                <button type="button" className="btn btn-outline-danger btn-circle btn-sm" onClick={() => removeItem(index)} ><i className="fa fa-remove"></i></button>
                                            </div>
                                        </div>
                                    );
                                }
                                return (
                                    <div key={arrayPath} className="form-group row">
                                        <label className="col-sm-1 col-form-label">{`#${index+1}`}</label>
                                        <div className="col-sm-10">
                                             <Field
                                                    type={getInputType(item)}
                                                    name={arrayPath}
                                                    className="form-control"
                                                    onChange={handleChange}
                                             />
                                        </div>
                                        <div className="col-sm-1">
                                            <button type="button" className="btn btn-outline-danger btn-circle btn-sm" onClick={() => removeItem(index)} ><i className="fa fa-remove"></i></button>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                );
            }
            console.log(fullPath, value)
            return (
                <div key={fullPath} className="form-group row">
                    <label className="col-sm-2 col-form-label">{key}</label>
                    <div className="col-sm-10">
                        <input
                            className="form-control"
                            type={inputType}
                            name={fullPath}
                            value={inputType === 'datetime-local' ? new Date(value).toISOString().slice(0, 16) : value}
                            onChange={(e) => handleChange(e, path)}
                        />
                    </div>
                </div>
            );
        };

        if (this.state.redirect) {
            return <Redirect push to={this.state.redirect} />;
        }
        return (
            <div>
                {this.state.obj && <Formik initialValues={this.state.obj} onSubmit={this.save}>
                    {({
                          values,
                          handleSubmit,
                          handleChange,
                          setFieldValue,
                          myHandleChange = evt => {
                              if(evt.target.type == "number" && evt.target.value == "")
                                  evt.target.value = null;
                              handleChange(evt);
                          },
                          isSubmitting
                      }) => (
                        <div className="card shadow w100">
                            <div className="card-header py-3">
                                <h2 className="m-0 font-weight-bold l text-capitalize">{this.collectionName}: <span className="text-primary">{values.name}</span></h2>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    {values._id != "new" && <div className="form-group row">
                                        <label className="col-sm-2 col-form-label">Id</label>
                                        <div className="col-sm-10">
                                            {values._id}
                                        </div>
                                    </div>}

                                    {Object.entries(values)
                                        .filter(([key]) => key !== '_id' && key !== '__v')
                                        .map(([key, value]) => renderField(key, value, '', myHandleChange, setFieldValue))}


                                    <button type="submit" className="btn btn-icon btn-success ml-1 r"><span className="fas fa-fw fa-save"></span>Save</button>
                                </form>
                            </div>
                        </div>
                    )}
                </Formik>}
            </div>
        );
    }
}